<template id="orderTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake ? '--invalid' : ''">
      <small class="--centered-block"
        >Select an order From the list to edit it</small
      >
      <div id="table-container" class="form-group col-12 col-sm-12">
        <label class="pl-0 col-12 col-sm-12">All Orders</label>
        <div class="mb-4 p-0 col-12 col-sm-12">
          <div class="p-0 col-12 col-sm-2">
            <label class="pl-0 col-12 col-sm-12">Order ID</label>
            <input
              class="form-control col-12 col-sm-12"
              type="text"
              maxlength="200"
              v-model="searchCriteria.id"
              placeholder="Order ID"
              v-on:input="
                searchPage = 1;
                fetchAllOrders();
              "
            />
          </div>
          <div class="p-0 col-12 col-sm-2">
            <label class="pl-0 col-12 col-sm-12">User's Email</label>
            <input
              class="form-control col-12 col-sm-12"
              type="text"
              maxlength="200"
              v-model="searchCriteria.email"
              placeholder="User's Email"
              v-on:input="
                searchPage = 1;
                fetchAllOrders();
              "
            />
          </div>
          <div class="p-0 col-12 col-sm-2">
            <label class="pl-0 col-12 col-sm-12">User's Mobile</label>
            <input
              class="form-control col-12 col-sm-12"
              type="number"
              maxlength="25"
              v-model="searchCriteria.mobile"
              placeholder="User's Mobile"
              v-on:input="
                searchPage = 1;
                fetchAllOrders();
              "
            />
          </div>
          <div class="p-0 col-12 col-sm-2">
            <label class="pl-0 col-12 col-sm-12">Order's Status</label>
            <b-form-select
              :disabled="formState.loading"
              class="modified-dropdown form-control col-12 col-sm-12"
              :options="orderStatuses"
              v-model="searchCriteria.status"
              v-on:input="
                searchPage = 1;
                fetchAllOrders();
              "
            ></b-form-select>
          </div>
        </div>
        <div class="order-row">
          <p class="order-heading">Id</p>
          <p class="order-heading">Status</p>
          <p class="order-heading">Total</p>
          <p class="order-heading">Sizeman price</p>
          <p class="order-heading">Delivery price</p>
          <p class="order-heading">Quantity Discount</p>
          <p class="order-heading">Expected total</p>
          <p class="order-heading">Ordering date</p>
          <p class="order-heading">Delivery date</p>
          <p class="order-heading">Pickable date</p>
          <p class="order-heading">Production date</p>
          <p class="order-heading">Payment method</p>
          <p class="order-heading">Delivery type</p>
          <p class="order-heading">Address</p>
          <p class="order-heading"></p>
        </div>
        <div
          v-for="(order, index) in fetchedOrders.filter((i) => {
            return i.user_id != null;
          })"
          v-on:click="
            $router.push({
              path: '/users/' + order.user_id + '/orders/' + order.id,
            })
          "
          class="order-row"
          :key="index"
        >
          <p class="order-col">{{ order.id }}</p>
          <p class="order-col">{{ getOrderStatusText(order.status) }}</p>
          <p class="order-col">{{ order.total }}</p>
          <p class="order-col">{{ order.size_man ? order.size_man : 0 }}</p>
          <p class="order-col">
            {{ order.delivery_cost ? order.delivery_cost : 0 }}
          </p>
          <p class="order-col">{{ order.quantity_discount }}</p>
          <p class="order-col">{{ order.expected_total }}</p>
          <p class="order-col">
            {{
              order.ordering_date
                ? new Date(order.ordering_date).toLocaleString("nl-NL", {
                    dateStyle: "short",
                    timeStyle: "medium",
                  })
                : ""
            }}
          </p>
          <p class="order-col">
            {{
              order.delivery_date
                ? new Date(order.delivery_date).toLocaleString("nl-NL", {
                    dateStyle: "short",
                    timeStyle: "medium",
                  })
                : ""
            }}
          </p>
          <p class="order-col">
            {{
              order.pickable_date
                ? new Date(order.pickable_date).toLocaleString("nl-NL", {
                    dateStyle: "short",
                    timeStyle: "medium",
                  })
                : ""
            }}
          </p>
          <p class="order-col">
            {{
              order.production_date
                ? new Date(order.production_date).toLocaleString("nl-NL", {
                    dateStyle: "short",
                    timeStyle: "medium",
                  })
                : ""
            }}
          </p>
          <div class="order-col">{{ order.payment_method }}
          <p v-if="order.payment_method == 'creditCard' || order.payment_method == 'tabbyPayment' || order.payment_method == 'tabbyPayLater'">
            <span v-if="order.payment_id != null" class="badge badge-success p-1">{{ order.payment_id  }}</span>
            <span v-if="order.payment_id == null" class="badge badge-danger p-1">Not Paid</span>
          </p>
          </div>
          <!-- <p class="order-col">{{ order.payment_method }}</p> -->
          <p class="order-col">{{ order.delivery_type }}</p>
          <p class="order-col">{{ order.address }}</p>
          <p class="order-col">
            <router-link
              :to="{ path: '/users/' + order.user_id + '/orders/' + order.id }"
            >
              more info
            </router-link>
          </p>
        </div>
        <div
          style="justify-content: center"
          v-if="fetchedOrders.length < 20"
          class="alert alert-info w-100"
        >
          No more orders
        </div>
        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="advancePageAndFetch(false)"
          v-if="
            (!isSearching() && searchCriteria.page > 1) ||
            (isSearching() && searchPage > 1)
          "
          :disabled="formState.loading"
        >
          Previous Page
        </button>
        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="advancePageAndFetch(true)"
          v-if="fetchedOrders.length >= 20"
          :disabled="formState.loading"
        >
          Next Page
        </button>
      </div>
    </div>
  </div>
</template>



<!-- order Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.component-container {
  min-height: 100%;
  display: flex;
}

#table-container {
  min-width: fit-content;
}

.main-div {
  font-size: 14px !important;
  font-weight: bold;
  overflow-x: visible;
  padding: 50px;
  width: 80%;
  ::-webkit-scrollbar {
    width: 0px;
    height: 5px;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: darkgray;
  }
  div {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }
  .--height-max-content {
    height: max-content;
  }
  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
  .separator {
    display: block;
    width: 100%;
    clear: both;
  }
  .--black-background {
    background-color: black;
  }

  .--centered-block {
    margin: 0 auto;
  }
  .default-tag {
    background-color: #17a2b8;
    border-style: solid;
    border-color: transparent;
    border-radius: 5px;
    font-size: 0.8em;
    padding: 0 5px;
    color: white;
  }

  .close-div-tag {
    background-color: #db0a5b;
    border-style: solid;
    border-color: transparent;
    border-radius: 5px;
    font-size: 0.8em;
    padding: 0 5px;
    color: white;
    cursor: pointer;
  }

  .order-row {
    width: max-content;
    padding: 5px;
    // overflow-x: scroll;
    height: auto;
    display: flex;
    border-radius: 5px;
    border-style: solid;
    border-color: transparent;
    background-color: #eeeeee;
    margin-bottom: 5px;
    cursor: pointer;
    &__measurement {
      cursor: default;
      padding-bottom: 10px !important;
    }
    &__order {
      cursor: default;
      padding-bottom: 10px !important;
      width: 100%;
    }
  }

  .order-heading {
    text-align: center;
    min-width: 120px;
    max-width: 120px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .order-col {
    text-align: center;
    min-width: 120px;
    max-width: 120px;
    overflow-x: scroll;
    margin-bottom: 0;
  }
}
//  0.82s
.--invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "ordersCRUD",
  data() {
    return {
      searchPage: 1,
      searchCriteria: { page: 1, email: null, id: null, status: null }, // We search All orders Depending on this.
      fetchedOrders: [], // fetched Orders (page dependant).
      searchedOrders: [], // Call API to search for orders.
      selectedOrderId: null, // Specifies The Id of the selected order in the database
      selectedOrderData: null, // Data is fetched from the backend using selectedOrderId
      orderStatuses: [
        { value: "new", text: "New - جديد" },
        {
          value: "pending_payment",
          text: "Pending Payment - فى إنتظار الحوالة",
        },
        { value: "production", text: "Production - فى الإنتاج" },
        { value: "charged", text: "Charged - تم الشحن" },
        { value: "delivered", text: "Delivered - تم التسليم" },
        { value: "pickable", text: "Pickable - جاهز للإستلام" },
        { value: "cancelled", text: "Cancelled - تم الإلغاء" },
      ],
      deliveryTypes: [
        { value: "home", text: "Home" },
        { value: "branch", text: "Branch" },
      ],
      errors: [], // Form's errors
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false,
      }, // Object Determining the Form's state
    };
  },
  watch: {},
  mounted() {
    this.fetchAllOrders();
  },
  methods: {
    isSearching() {
      return !(
        (this.searchCriteria.id == "" || this.searchCriteria.id == null) &&
        (this.searchCriteria.email == "" ||
          this.searchCriteria.email == null) &&
        (this.searchCriteria.mobile == "" ||
          this.searchCriteria.mobile == null) &&
        this.searchCriteria.status == null
      );
    },
    advancePageAndFetch: function (increment) {
      if (increment) {
        if (this.isSearching()) {
          this.searchPage++;
        } else {
          this.searchCriteria.page++;
        }
      } else {
        if (this.isSearching()) {
          this.searchPage--;
        } else {
          this.searchCriteria.page--;
        }
      }
      this.fetchAllOrders();
    },
    // Partially resets the form
    partiallyResetForm: function () {
      // this.cancelNewOrder();
      this.fetchAllOrders();
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false,
      };
    },
    smoothScroll(elemId) {
      document.getElementById(elemId).scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
      });
    },
    fetchAllOrders() {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllorders-2`,
          {
            ...this.searchCriteria,
            pageIndex: this.isSearching()
              ? this.searchPage
              : this.searchCriteria.page,
            pageSize: 20,
            email:
              this.searchCriteria.email == ""
                ? null
                : this.searchCriteria.email,
            mobile:
              this.searchCriteria.mobile == ""
                ? null
                : this.searchCriteria.mobile,
            id: this.searchCriteria.id == "" ? null : this.searchCriteria.id,
          },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then((res) => {
          this.fetchedOrders = res.data.orders;
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Orders fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    changeOrderStatus(orderId, newStatus) {
      this.formState.attempted = true;
      if (
        confirm("Please confirm you want to update the selected Order's status")
      ) {
        {
          this.formState.loading = true;
          return axios
            .put(
              `${herokuUrl}/dashboard/update-order-status`,
              {
                orderId: orderId,
                orderStatus: newStatus,
              },
              {
                headers: {
                  Authorization: getCookie("user"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                alert("Order was Edited successfully");
                // this.partiallyResetForm();
                this.fetchAllOrders();
              } else {
                alert(
                  "There was a problem editing the selected Order " +
                    res.data.message
                );
              }
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected Order " +
                    err.response.data.message
                );
              }
            });
        }
      }
    },
    changeOrderDeliveryType(orderId, newDeliveryType) {
      this.formState.attempted = true;
      if (
        confirm(
          "Please confirm you want to update the selected order's delivery type"
        )
      ) {
        {
          this.formState.loading = true;
          return axios
            .put(
              `${herokuUrl}/dashboard/change-order-delivery`,
              {
                orderId: this.selectedOrderData.id,
                deliveryMethod: this.selectedOrderData.delivery_type,
              },
              {
                headers: {
                  Authorization: getCookie("user"),
                },
              }
            )
            .then(() => {
              alert("Order was Edited successfully");
              // this.partiallyResetForm();
              this.fetchAllOrderOrders(this.selectedOrderId);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected Order " +
                    err.response.data.message
                );
              }
            });
        }
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function () {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
    /**
     * Get modified Order Status text instead of API Status
     * @param  {string} apiStatus Order Status from API (i.e. "pending_payment")
     * @return {string} Modified Order Status according to "orderStatuses" array of objects
     */
    getOrderStatusText(apiStatus) {
      let result = this.orderStatuses.filter((status) => {
        return status.value == apiStatus;
      });
      return result[0].text;
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
